import type {
  EditVehicleDocumentForm,
  EditVehicleExpirationForm,
} from '@/modules/vehicles'
import { subWeeks } from 'date-fns'

/**
 * The notification time is stored as an absolute timestamp but entered as
 * "weeks before the expiration date", and both are cleared when the user turns
 * the notification off.
 */
export function getExpirationAndNotificationTime(
  form: EditVehicleDocumentForm | EditVehicleExpirationForm,
  hasNotification: boolean
) {
  const expirationDate = !hasNotification ? null : form.expirationDate
  const notificationTime =
    !hasNotification || !expirationDate || !form.notificationTime
      ? null
      : subWeeks(expirationDate, form.notificationTime)

  return { expirationDate, notificationTime }
}
